
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":".5","width":"41.5","height":"29","rx":"3.5","fill":"#fff","stroke":"#B2BCCA"}}),_c('path',{attrs:{"d":"M23.903 26.288c6.063.03 11.597-4.944 11.597-10.995 0-6.616-5.534-11.19-11.597-11.188h-5.217C12.55 4.103 7.5 8.678 7.5 15.293c0 6.052 5.05 11.024 11.186 10.995h5.217z","fill":"#0079BE"}}),_c('path',{attrs:{"d":"M18.71 5.022c-5.606.002-10.15 4.546-10.15 10.155 0 5.608 4.544 10.152 10.15 10.153 5.608-.001 10.152-4.545 10.153-10.153 0-5.609-4.545-10.153-10.153-10.155zm-6.434 10.155a6.446 6.446 0 014.13-6.007v12.012a6.443 6.443 0 01-4.13-6.005zm8.737 6.008V9.17a6.443 6.443 0 014.133 6.007 6.445 6.445 0 01-4.133 6.008z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.71 5.022c-5.606.002-10.15 4.546-10.15 10.155 0 5.608 4.544 10.152 10.15 10.153 5.608-.001 10.152-4.545 10.153-10.153 0-5.609-4.545-10.153-10.153-10.155zm-6.434 10.155a6.446 6.446 0 014.13-6.007v12.012a6.443 6.443 0 01-4.13-6.005zm8.737 6.008V9.17a6.443 6.443 0 014.133 6.007 6.445 6.445 0 01-4.133 6.008z","fill":"#fff"}})])
          )
        }
      }
    